/**
 * Framer Motion animation variants.
 * Reusable across all components for consistent motion design.
 */
import type { Variants } from 'framer-motion';

/** Fade in from transparent */
export const fadeIn: Variants = {
  hidden:  { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
  exit:    { opacity: 0, transition: { duration: 0.15 } },
};

/** Fade in + slide up (for page content, cards) */
export const fadeInUp: Variants = {
  hidden:  { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3, ease: [0.23, 1, 0.32, 1] } },
  exit:    { opacity: 0, y: -8, transition: { duration: 0.2 } },
};

/** Staggered children (for lists, grids) */
export const staggerContainer: Variants = {
  hidden:  { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.05, delayChildren: 0.05 },
  },
};

export const staggerItem: Variants = {
  hidden:  { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.25, ease: [0.23, 1, 0.32, 1] } },
};

/** Scale in (for modals, popovers) */
export const scaleIn: Variants = {
  hidden:  { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.2, ease: [0.23, 1, 0.32, 1] } },
  exit:    { opacity: 0, scale: 0.95, transition: { duration: 0.15 } },
};

/** Slide in from left (for sidebar, drawers) */
export const slideInLeft: Variants = {
  hidden:  { opacity: 0, x: -16 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.25, ease: [0.23, 1, 0.32, 1] } },
  exit:    { opacity: 0, x: -16, transition: { duration: 0.15 } },
};

/** Slide in from right (for panels) */
export const slideInRight: Variants = {
  hidden:  { opacity: 0, x: 16 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.25, ease: [0.23, 1, 0.32, 1] } },
  exit:    { opacity: 0, x: 16, transition: { duration: 0.15 } },
};

/** Collapse/expand (for accordions, filter groups) */
export const collapse: Variants = {
  hidden:  { height: 0, opacity: 0, overflow: 'hidden' },
  visible: { height: 'auto', opacity: 1, overflow: 'visible', transition: { duration: 0.25, ease: [0.23, 1, 0.32, 1] } },
  exit:    { height: 0, opacity: 0, overflow: 'hidden', transition: { duration: 0.2 } },
};

/** Page transition wrapper */
export const pageTransition: Variants = {
  hidden:  { opacity: 0, y: 6 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3, ease: [0.23, 1, 0.32, 1] } },
  exit:    { opacity: 0, y: -6, transition: { duration: 0.2 } },
};
